<template>
  <div v-loading="loading">
    <div class="desc-enterprise">
      <span>{{companyName}}</span>
      的企业综合评级为
      <span>{{scoreTotalLevel}}</span>
      级，企业综合评分在
      <span>{{industryName}}行业</span>
      中的位于
      <span>前{{industryRank}}%</span>
    </div>
    <div class="fx">
      <div class="chart fx-full">
        <img src="@/assets/panel/dash-board.png" alt="" srcset="" class="chart-bg">
        <MyEcharts ref="myEchart" style="width: 100%;height:240px;" />
      </div>
      <div class="fx-full info-box pt-60">
        <el-descriptions :column='1'>
          <el-descriptions-item label="综合评级" labelClassName="label">
            <div class="value">{{scoreTotalLevel}}级</div>
          </el-descriptions-item>
          <el-descriptions-item label="行业排名" labelClassName="label">
            <div class="value">{{industryName}}行业前{{industryRank}}%</div>
          </el-descriptions-item>
          <el-descriptions-item label="区域排名" labelClassName="label">
            <div class="value"> {{regionName}}前{{regionRank}}%</div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>

    <div>
      <EnterpriseSub v-for="(item,i) in scoreVO" :key="i" :data="item" />
    </div>
  </div>
</template>

<script>
import MyEcharts from '@/components/myEcharts'
import { gaugeChart } from '@/views/clue/components/echartsOptions'
import EnterpriseSub from '@/views/clue/components/enterpriseSub'
import {
  enterpriseEvaluate,

  evaluateScale, evaluateCredit, evaluateFinance, evaluateGrowth, evaluateInnovation, evaluateStability

} from '@/views/clue/api/newClueApi'
export default {
  name: 'EnterpriseRate',
  components: {
    MyEcharts,
    EnterpriseSub
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      rateData: {},
      hid: '',
      scoreVO: [],
      loading: false
    }
  },
  computed: {
    companyName() { return this.formatFelid(this.data?.companyName) },
    scoreTotalLevel() { return this.formatFelid(this.rateData?.scoreTotalLevel) },
    industryName() { return this.formatFelid(this.rateData?.industryName) },
    regionRank() { return this.formatFelid(this.rateData?.regionRank) },
    industryRank() { return this.formatFelid(this.rateData?.industryRank) },
    regionName() { return this.formatFelid(this.rateData?.regionName) },
  },
  watch: {
    'data.hid': {
      immediate: true,
      handler: function (hid) {
        this.hid = hid
        hid && this.enterpriseEvaluate(hid)
      }
    },
    // 'rateData.scoreTotal': {
    //   immediate: true,
    //   handler: function (hid) {
    //    this.initMap()
    //   }
    // }
  },
  mounted() {
  },
  methods: {
    initMap() {
      this.$refs.myEchart?.update(gaugeChart(this.rateData.scoreTotal || 0))
    },
    async enterpriseEvaluate(hid) {
      this.loading = true
      let { data, code } = await enterpriseEvaluate({ hid })
      if (code === 200) {
        this.rateData = data || {}

        this.scoreVO = data.scoreVO || []
        this.initMap()
        Promise.all([
          // 规模
          this.evaluateScale(),
          // 稳定
          this.evaluateStability(),
          // 履约
          this.evaluateCredit(),
          // 成长
          this.evaluateGrowth(),
          //  财务
          this.evaluateFinance(),
          // 创新
          this.evaluateInnovation()
        ]).finally(_ => this.loading = false)
      }
    },
    // 规模
    async evaluateScale() {
      let { data, code } = await evaluateScale({ hid: this.hid })
      if (code === 200) {
        data = data || []
        this.scoreVO?.find(e => {
          if (e.type === 'CS') {
            const params = {
              ...data,
              tips: `分析该企业的注册资本、投资金额、经营范围、市场规模等情况，评估该企业的规模得分为
              <span class="yellow">${this.formatFelid(e.score)}分</span>，规模评级为
              <span class="yellow">${this.formatFelid(e.grade)}级</span>`,
              typeText: '规模',
              imgField: 1,
              subBlock: [
                {
                  title: '注册规模',
                  children: [
                    `企业注册成立${this.formatFelid(data.regScaleVO.establishYear)}年`,
                    `注册资本为${this.formatFelid(data.regScaleVO.regCapital)}万元`,
                    `持股注册资本为${this.formatFelid(data.regScaleVO.paidCapital)}万元`,
                  ]
                },
                {
                  title: '经营规模',
                  children: [
                    `社保人数为${this.formatFelid(data.manageScaleVO.socialSecurity)}人`,
                    // `两年内招标数量为${this.formatFelid(data.manageScaleVO.issueTwoYears)}次`,
                    // `两年内中标数量为${this.formatFelid(data.manageScaleVO.resultTwoYears)}次`,
                  ]
                }
              ]
            }
            this.$set(e, 'detail', params)
          }
        })
      }
    },
    // 履约
    async evaluateCredit() {
      let { data, code } = await evaluateCredit({ hid: this.hid })
      if (code === 200) {
        data = data || []

        this.scoreVO?.find(e => {
          if (e.type === 'CP') {
            const params = {
              ...data,
              tips: `分析该企业的经营异常、纳税异常、行政处罚、司法诉讼、股权出质等情况，评估该企业的履约得分为
              <span class="yellow">${this.formatFelid(e.score)}分</span>，履约评级为<span class="yellow">${this.formatFelid(e.grade)}级</span>`,
              typeText: '履约',
              imgField: 6,
              subBlock: [
                {
                  title: '司法诉讼',
                  children: [
                    `开庭公告${this.formatFelid(data.judicialVO.courtCount)}次`,
                    `裁判文书${this.formatFelid(data.judicialVO.lawsuitCount)}次`,
                  ]
                },
                {
                  title: '行政处罚',
                  children: [
                    `行政处罚${this.formatFelid(data.operateRickVO.punishmentCount)}次`,
                    `股权出质${this.formatFelid(data.operateRickVO.pledgeCount)}次`,
                  ]
                },
                {
                  title: '经营异常',
                  children: [
                    `失信被执行${this.formatFelid(data.judicialVO.dishonestCount)}次`,
                    `被执行${this.formatFelid(data.judicialVO.executionCount)}次`,
                    `异常经营${this.formatFelid(data.operateRickVO.anomalyCount)}次`,
                  ]
                }
              ]
            }
            this.$set(e, 'detail', params)
          }
        })

      }
    },
    // 财务
    async evaluateFinance() {
      let { data, code } = await evaluateFinance({ hid: this.hid })
      if (code === 200) {
        data = data || []

        this.scoreVO?.find(e => {
          if (e.type === 'FBT') {
            const params = {
              ...data,
              tips: `分析该企业的资产规模、盈利能力、运营能力、偿债能力等情况，评估该企业的财务得分为
              <span class="yellow">${this.formatFelid(e.score)}分</span>，财务评级为
              <span class="yellow">${this.formatFelid(e.grade)}级</span>`,
              typeText: '财务',
              imgField: 5,
              subBlock: [
                {
                  title: '盈利能力',
                  children: [
                    `净利润率${this.formatFelid(data.retainedProfitRate)}`,
                    `毛利润率${this.formatFelid(data.grossProfitRate)}`,
                  ]
                },
                {
                  title: '运营能力',
                  children: [
                    `总资产周转率${this.formatFelid(data.totalAssetTurnoverRate)}`
                  ]
                },
                {
                  title: '偿债能力',
                  children: [
                    `资产负债率${this.formatFelid(data.debtToAssetRate)}`
                  ]
                }
              ]
            }
            this.$set(e, 'detail', params)
          }
        })

      }
    },
    //  成长
    async evaluateGrowth() {
      let { data, code } = await evaluateGrowth({ hid: this.hid })
      if (code === 200) {
        data = data || []

        this.scoreVO?.find(e => {
          if (e.type === 'CI') {
            const params = {
              ...data,
              tips: `分析该企业的扩张速度、业绩增长、所在行业的用户体量增长、融资等情况，评估该企业的成长得分为
              <span class="yellow">${this.formatFelid(e.score)}分</span>，成长评级为
              <span class="yellow">${this.formatFelid(e.grade)}级</span>`,
              typeText: '成长',
              imgField: 3,
              subBlock: [
                {
                  title: '私募融资',
                  children: data.financingSummaryVO ? [
                    `近两年融资${this.formatFelid(data.financingSummaryVO.totalCountTwoYears)}次`,
                    `最新融资${this.formatFelid(data.financingSummaryVO.latestRound)}轮`,
                    `累计融资金额${this.formatFelid(data.financingSummaryVO.totalAmount)}万元`,
                  ] : []
                },
                {
                  title: '财税增长',
                  children: [
                    `营业收入增长率${this.formatFelid(data.taxGrowth.gror)}%`,
                    `净利润增长率${this.formatFelid(data.taxGrowth.netProfitGrowthRate)}%`,
                  ]
                }
              ]
            }
            this.$set(e, 'detail', params)
          }
        })

      }
    },
    // - 创新
    async evaluateInnovation() {
      let { data, code } = await evaluateInnovation({ hid: this.hid })
      if (code === 200) {
        data = data || []

        this.scoreVO?.find(e => {
          if (e.type === 'INNO') {
            const params = {
              ...data,
              tips: `分析该企业的科技资源、研发能力、专利数量及结构、专利状态、专利趋势等情况，评估该企业的创新得分为
              <span class="yellow">${this.formatFelid(e.score)}分</span>，创新评级为
              <span class="yellow">${this.formatFelid(e.grade)}级</span>`,
              typeText: '创新',
              imgField: 4,
              subBlock: [
                {
                  title: '专利',
                  children: [
                    `申请专利${this.formatFelid(data.applyPatentCount)}个`,
                    `两年内申请专利${this.formatFelid(data.applyPatentSecCount)}个`
                  ]
                },
                {
                  title: '软件著作权(软著)',
                  children: [
                    `申请软著${this.formatFelid(data.softwareCopyrightCount)}个`,
                    `两年内申请软著${this.formatFelid(data.softwareCopyrightSecCount)}个`
                  ]
                },
                {
                  title: '作品著作权',
                  children: [
                    `申请作品著作权${this.formatFelid(data.copyrightCount)}个`,
                    `两年内申请作品著作权${this.formatFelid(data.copyrightSecCount)}个`
                  ]
                }
              ]
            }
            this.$set(e, 'detail', params)
          }
        })

      }
    },
    // 稳定
    async evaluateStability() {
      let { data, code } = await evaluateStability({ hid: this.hid })
      if (code === 200) {
        data = data || []

        this.scoreVO?.find(e => {
          if (e.type === 'STA') {
            const params = {
              ...data,
              tips: `分析该企业的法人及高管变更、股东变更、其他工商变更、供应链关系、税务评级等情况，评估该企业的稳定得分为
              <span class="yellow">${this.formatFelid(e.score)}分</span>，稳定评级为
              <span class="yellow">${this.formatFelid(e.grade)}级</span>`,
              typeText: '稳定',
              imgField: 2,
              subBlock: [
                {
                  title: '核心人员变更',
                  children: [
                    `法人变更${this.formatFelid(data.personChangeVO.legalPersonFrequency)}次`,
                    `股东/高管变更${this.formatFelid(data.personChangeVO.shareholderExecFrequency)}次`,
                  ]
                },
                {
                  title: '工商变更',
                  children: [
                    `工商变更${this.formatFelid(data.businessAlterVO.businessAlterFrequency)}次`,
                    `经营范围变更${this.formatFelid(data.businessAlterVO.businessScopeFrequency)}次`,
                    `经营地址变更${this.formatFelid(data.businessAlterVO.businessAddressFrequency)}次`,
                  ]
                }
              ]
            }
            this.$set(e, 'detail', params)
          }
        })

      }
    },
    formatFelid(val) {
      if (typeof val === 'number') return val
      if (!val) return '--'
      return val
    }
  }
}
</script>

<style scoped lang="scss">
.info-box {
  ::v-deep .label {
    font-weight: 400;
    color: #86909c;
    flex-shrink: 0;
  }
  .value {
    font-weight: 500;
    color: #586474;
  }
}
.chart {
  // width: 100%;
  position: relative;
  .chart-bg {
    position: absolute;
    height: 200px;
    left: 50%;
    top: 0;
    transform: translate(-50%);
  }
}
.desc-enterprise {
  font-size: 14px;
  color: #646464;
  padding: 16px;
  span {
    font-weight: 600;
  }
}
</style>
